/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name Stocktakes
 */
angular.module('mercury.modules.stock.stocktake')
.factory('Stocktakes', ["$resource", "$q", "settings", function($resource, $q, settings) {
  var Stocktake = $resource(settings.apiHost + '/r/Stocktakes/:id', {id: '@id'});
  var StocktakeLine = $resource(settings.apiHost + '/r/StocktakeLines/:id', {id: '@id'});
  var StocktakeArea = $resource(settings.apiHost + '/r/StocktakeAreas/:id', {id: '@id'});
  var StockakeAreaLines = $resource(settings.apiHost + '/r/StocktakeAreaLines/:id', {id: '@id'});
  var StocktakeRecipes = $resource(settings.apiHost + '/r/StocktakeRecipes/:id', {id: '@id'});
  var StocktakeTemplates = $resource(settings.apiHost + '/r/StocktakeTemplates');
  var ItemSuperGroups = $resource(settings.apiHost + '/r/StockItemSuperGroups');

  // Stock API endpoints
  var StocktakeStockApi = $resource(settings.stockHost + '/internal/stocktakes/:id', {id: '@id'})
  var StocktakeLineStockApi = $resource(settings.stockHost + '/internal/stocktake-lines/:id', {id: '@id'})

  /**
   * Get all pending stocktakes
   *
   * @memberof Stocktakes
   */
  function getAllActive() {
    return Stocktake.query({$filter: 'Pending eq true', $orderby: 'DateStampCreated'});
  }

  /**
   * Get all completed stocktake in a period
   *
   * @memberof Stocktakes
   * @param  {String} startTime start of period
   * @param  {String} endTime   end of period
   */
  function getArchive(startTime, endTime) {
    return Stocktake.query({
      $filter: 'Pending eq false and DatestampCompleted gt ' + startTime + ' and DatestampCompleted lt ' + endTime,
      $orderby: 'DateStampCreated desc'
    });
  }

  /**
   * get a specific stocktake
   *
   * @memberof Stocktakes
   * @param  {String} id Id of the stocktake
   */
  function get(id) {
    var deferred = $q.defer();

    Stocktake.get({id: id}, function(stocktake) {
      //Wrap each stocktake line in a resource so we can just update them directly
      angular.forEach(stocktake.lines, function(line, index) {
        stocktake.lines.splice(index, 1, new StocktakeLine(line));
      });

      deferred.resolve(stocktake);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * get a specific stocktake via the Stock API
   *
   * @memberof Stocktakes
   * @param  {String} id Id of the stocktake
   */
    function getStockApi(id) {
      var deferred = $q.defer();
  
      StocktakeStockApi.get({id: id}, function(stocktake) {
        //Wrap each stocktake line in a resource so we can just update them directly
        angular.forEach(stocktake.lines, function(line, index) {
          stocktake.lines.splice(index, 1, new StocktakeLine(line));
        });
  
        deferred.resolve(stocktake);
      }, function(response) {
        deferred.reject(response);
      });
  
      return deferred.promise;
    }

  /**
   * Get the stocktake recipes for a given stocktake
   *
   * @memberof Stocktakes
   * @param  {String} stocktakeId Id of the stocktake
   */
  function getRecipes(stocktakeId) {
    return StocktakeRecipes.query({stocktakeId: stocktakeId});
  }

  /**
   * Get the stocktake areas for a given stocktake
   *
   * @memberof Stocktakes
   * @param  {String} stocktakeId if of the stocktake
   */
  function getAreas(stocktakeId) {
    return StocktakeArea.query({stocktakeId: stocktakeId});
  }

  /**
   * Get a specific stocktake area
   *
   * @memberof Stocktakes
   * @param  {String} areaId Id of the stocktake area
   */
  function getArea(areaId) {
    return StocktakeArea.get({id: areaId});
  }

  /**
   * Create a new stocktake
   *
   * @memberof Stocktakes
   * @param  {String} params new stocktake parameters
   */
  function create(params) {
    return Stocktake.save(params, {}).$promise;
  }

  /**
   * Create a new stocktake area
   *
   * @memberof Stocktakes
   * @param  {String} stocktakeId Id of the stocktake
   * @param  {String} templateId  template to use as the stocktake area
   */
  function createArea(stocktakeId, templateId) {
    return StocktakeArea.save({stocktakeId: stocktakeId, templateId: templateId}, {}).$promise;
  }

  /**
   * Update a stocktake
   *
   * @memberof Stocktakes
   * @param  {String} stocktake Updated stocktake model
   */
  function update(stocktake) {
    return Stocktake.update(stocktake).$promise;
  }

  /**
   * Update a stocktake via Stock API
   *
   * @memberof Stocktakes
   * @param  {String} stocktake Updated stocktake model
   */
    function updateStockApi(stocktake) {
      return StocktakeStockApi.update(stocktake).$promise;
    }

  /**
   * Update a stocktake line
   *
   * @memberof Stocktakes
   * @param  {String} line Updated stocktake line model
   */
  function updateLine(line) {
    return line.$update();
  }

  /**
   * Update a stocktake line via Stock API
   *
   * @memberof Stocktakes
   * @param  {String} line Updated stocktake line model
   */
  function updateLineStockApi(line) {
    return StocktakeLineStockApi.update(line).$promise
  }

  /**
   * Update a stocktake recipe
   *
   * @memberof Stocktakes
   * @param  {String} recipe Updated stocktake recipe model
   */
  function updateRecipe(recipe) {
    return recipe.$update();
  }

  /**
   * Update a stocktake area line
   *
   * @memberof Stocktakes
   * @param  {String} areaLine Stocktake area line model
   */
  function updateAreaLine(areaLine) {
    return StockakeAreaLines.update(areaLine).$promise;
  }

  /**
   * Remove a stocktake
   *
   * @memberof Stocktakes
   * @param  {String} stocktake Stocktake model
   */
  function remove(stocktake) {
    return stocktake.$delete();
  }

  /**
   * Remove a stocktake area
   *
   * @memberof Stocktakes
   * @param  {String} area area model
   */
  function removeArea(area) {
    return area.$delete();
  }

  /**
   * Get options for new stocktakes
   *
   * @memberof Stocktakes
   */
  function stocktakeTypes() {
    var deferred = $q.defer();

    var templates = StocktakeTemplates.query();
    var superGroups = ItemSuperGroups.query();
    $q.all([templates.$promise, superGroups.$promise]).then(function() {
      var rtn = [];
      angular.forEach(superGroups, function(superGroup) {
        rtn.push({
          id: superGroup.id,
          type: 1,
          title: 'All ' + superGroup.name
        });
      });
      angular.forEach(templates, function(template) {
        rtn.push({
          id: template.id,
          type: 2,
          title: template.title,
          isDeleted: template.datestampDeleted !== null
        });
      });
      deferred.resolve(rtn);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  return {
    get: get,
    getStockApi,
    getAllActive: getAllActive,
    getArchive: getArchive,
    getRecipes: getRecipes,
    getAreas: getAreas,
    getArea: getArea,
    create: create,
    createArea: createArea,
    update: update,
    updateStockApi,
    updateLine: updateLine,
    updateLineStockApi,
    updateRecipe: updateRecipe,
    updateAreaLine: updateAreaLine,
    remove: remove,
    removeArea: removeArea,
    stocktakeTypes: stocktakeTypes
  };
}]);
